/*
 * @Description: axios utils
 * @Author: 山淑兰
 * @Date: 2019-12-26 10:32:28
 * @LastEditTime: 2020-05-21 10:48:26
 * @LastEditors: 山淑兰
 */

/**
 * Created by VULCAN on 2018/8/8.
 */
import { AxiosPromise } from "axios";
import axios from "./config";
import pick from "lodash/pick";

interface IAxiosConfig {
  url: string;
  headers?: any;
  params?: any;
}
export const Get = (opts: IAxiosConfig): Promise<IResults> => {
  let { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "get",
    url,
    headers,
    params,
  });
};
export const Post = (opts: IAxiosConfig): Promise<IResults> => {
  const { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "post",
    url,
    headers,
    data: params,
  });
};

export const Delete = (opts: IAxiosConfig): Promise<IResults> => {
  const { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "delete",
    url,
    headers,
    data: params,
  });
};
export const DeleteParam = (opts: IAxiosConfig): Promise<IResults> => {
  const { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "delete",
    url,
    headers,
    data: params,
  });
};
export const Put = (opts: IAxiosConfig): Promise<IResults> => {
  const { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "put",
    url,
    headers,
    data: params,
  });
};
export const PutParam = (opts: IAxiosConfig) => {
  const { url, headers, params = {} } = opts;
  return <Promise<any>>axios({
    method: "put",
    url,
    headers,
    data: params,
  });
};

export const Pick = <T>(params: any, dto: T): T => {
  const includeParams = new (dto as any)();
  const data = pick(params, Object.keys(includeParams));
  return data as T;
};
